<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text class="">
            <h2 class="indigo--text text--darken-4"><u>Formations</u></h2>
            <br>
            <v-timeline align-top>
                <v-timeline-item v-for="item in items" :key="item.year" :color="item.color" :icon="item.icon">
                    <v-card class="blue-grey lighten-2">
                        <v-card-title class="justify-center" :class="item.color">
                            {{ item.year }}
                        </v-card-title>
                        <v-card-text class="blue-grey lighten-5 pt-5 grey--text text--darken-3" v-html="item.value">
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Learnings',
    data: () => ({
        items: [
            { year:2012, value:'<strong>Formation Java / J2EE</strong> (70H), chez Global Consulting Institut (Cenon)', color:'indigo darken-4 white--text', icon:'fab fa-java' },
            { year:2002, value:'<strong>BTS informatique de Gestion</strong>, option Développeur d\'application, au lycée G.Eiffel (Bordeaux)', color:'grey darken-3 white--text', icon:'fa-code' },
            { year:2000, value:'<strong>Baccalauréat</strong> général section ES (Economique et Social), <strong>mention Bien</strong> (Bordeaux)', color:'blue-grey darken-3 white--text', icon:'fa-search-dollar' }
        ]
    }),
}
</script>
